// mutations-types
const SET_CLINET_HEIGHT = "SET_CLINET_HEIGHT";
const SET_CLINET_WIDTH = "SET_CLINET_WIDTH";
const SET_IS_PHONEX = "SET_IS_PHONEX";
const SET_IS_ALLOW_BACK = "SET_IS_ALLOW_BACK";
const SET_IS_SELF_BACK = "SET_IS_SELF_BACK";
const SET_INCLUDE_KEEPLIVE = "SET_INCLUDE_KEEPLIVE";
export default {
    namespaced: true,
    state: {
        clientWidth: null,
        clientHeight: null,
        isIphoneX: false,
        isAllowBack:false,
        isSelfBack:false,
        includeKeeplive:["DocDetail","DocList","groupList","PatDetail","patListIndex"],
    },
    mutations: {
        [SET_CLINET_HEIGHT] (state, data) {
            state.clientHeight = data;
        },
        [SET_CLINET_WIDTH] (state, data) {
            state.clientWidth = data;
        },
        [SET_IS_PHONEX] (state, data) {
            state.isIphoneX = data;
        },
        [SET_IS_ALLOW_BACK] (state, data) {
            state.isAllowBack = data;
        },
        [SET_IS_SELF_BACK] (state, data) {
            state.isSelfBack = data;
        },
        [SET_INCLUDE_KEEPLIVE](state, data) {
            state.includeKeeplive = data;
        },
    },
    actions: {},
    getters: {
        clientHeight (state) {
            return state.clientHeight;
        },
        clientWidth (state) {
            return state.clientWidth;
        },
        isIphoneX (state) {
            return state.isIphoneX;
        },
        isAllowBack (state) {
            return state.isAllowBack;
        },
        isSelfBack (state) {
            return state.isSelfBack;
        },
        includeKeeplive (state) {
            return state.includeKeeplive;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/deviceInfo.js